import { render, staticRenderFns } from "./vehicleboardassociation.vue?vue&type=template&id=26f660ea&scoped=true"
import script from "./vehicleboardassociation.vue?vue&type=script&lang=js"
export * from "./vehicleboardassociation.vue?vue&type=script&lang=js"
import style0 from "./vehicleboardassociation.vue?vue&type=style&index=0&id=26f660ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f660ea",
  null
  
)

export default component.exports